import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCYeAQtQFGrwgQl0qjK7q4IL8zNyDAfGfU",
  authDomain: "sahara-public.firebaseapp.com",
  projectId: "sahara-public",
  storageBucket: "sahara-public.firebasestorage.app",
  messagingSenderId: "878534423459",
  appId: "1:878534423459:web:e13f08106b80088debe016",
  measurementId: "G-515F3DG282",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
